export default __webpack_public_path__ + "static/monikao-70abb08b892405b331ac2b2934a1ce96.webp";